import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { findWidgetForGridSlot } from '../dashboard-layouts.utils';

const useStyles = makeStyles({
  tableColumn: {
    minHeight: '500px',
    maxHeight: '700px',
    overflowY: 'auto',
    overflowX: 'auto',
    display: 'inline-grid'
  },
  chartStyle: {
    width: '100%',
    minHeight: '220px',
    maxHeight: '340px',
    overflowY: 'auto',
    overflowX: 'auto',
    display: 'inline-grid'
  }
});

const LayoutE = props => {
  const classes = useStyles();
  const { singleColumnWidth, columnWithItemsWidth, rowElementsWidth, availableSlots } = props;
  const remainingItems = [...Array(availableSlots - 4).keys()].map(item => 4 + item);

  const calculateWidgetForSlot = useCallback(slot => findWidgetForGridSlot({ ...props, slot }), [
    props
  ]);

  return (
    <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={1}>
      <Grid item xs={12} md={singleColumnWidth} className={classes.tableColumn}>
        {calculateWidgetForSlot(0)}
      </Grid>
      <Grid
        item
        container
        direction="row"
        justify="flex-start"
        alignItems="stretch"
        xs={12}
        md={columnWithItemsWidth}
        spacing={1}
      >
        <Grid item container direction="row" alignItems="stretch" spacing={1}>
          <Grid item xs={12} className={classes.chartStyle}>
            {calculateWidgetForSlot(1)}
          </Grid>
          <Grid item xs={12} className={classes.chartStyle}>
            {calculateWidgetForSlot(3)}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={singleColumnWidth} className={classes.tableColumn}>
        {calculateWidgetForSlot(2)}
      </Grid>
      {remainingItems &&
        remainingItems.map(item => (
          <Grid
            key={`widget-grid-key-${item}`}
            item
            xs={12}
            md={rowElementsWidth}
            className={classes.chartStyle}
          >
            {calculateWidgetForSlot(item)}
          </Grid>
        ))}
    </Grid>
  );
};

LayoutE.propTypes = {
  singleColumnWidth: PropTypes.number,
  columnWithItemsWidth: PropTypes.number,
  rowElementsWidth: PropTypes.number,
  availableSlots: PropTypes.number
};

LayoutE.defaultProps = {
  singleColumnWidth: 4,
  columnWithItemsWidth: 4,
  rowElementsWidth: 4,
  availableSlots: 11
};

export default LayoutE;
